module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SiteSection', {
    attrs: {
      "sectionId": "section-why-us",
      "sectionNo": "1",
      "label": "關於新芽實習計畫",
      "title": "WHY US?"
    }
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('ContentBlock', {
    attrs: {
      "isBlank": "true"
    }
  }), _vm._v(" "), _c('ContentBlock', {
    attrs: {
      "labelName": "Reason",
      "labelNo": "01",
      "illustration": _vm.images.why01,
      "enTitle": "Work with creative people",
      "cnTitle": "一起創造分享新事物",
      "contentText": "創意發想與設計需要跳脫現狀，我們從不吝嗇分享突然冒出來的新點子，並相信透過整個團隊可以激盪更多靈感並做出不一樣的事情。"
    }
  }), _vm._v(" "), _c('ContentBlock', {
    attrs: {
      "labelName": "Reason",
      "labelNo": "02",
      "illustration": _vm.images.why02,
      "enTitle": "We shape company culture together",
      "cnTitle": "共同塑造公司文化",
      "contentText": "我們歡迎各種垃圾話或天馬行空的想法，也樂於接受不同角度的思維與作法，新芽每一份子都會一起形塑並傳播公司文化。"
    }
  }), _vm._v(" "), _c('ContentBlock', {
    attrs: {
      "labelName": "Reason",
      "labelNo": "03",
      "illustration": _vm.images.why03,
      "enTitle": "Take initiatives in projects",
      "cnTitle": "主導專案進行的機會",
      "contentText": "新芽的團隊組織架構非常扁平，我們每個人都有機會參與並主導專案或計畫的進行，把不同的構想連結並有效率的執行。"
    }
  }), _vm._v(" "), _c('ContentBlock', {
    attrs: {
      "labelName": "Reason",
      "labelNo": "04",
      "illustration": _vm.images.why04,
      "enTitle": "Promotion opportunities",
      "cnTitle": "升遷為正職夥伴的機會",
      "contentText": "實習期間表現優異，我們會非常誠摯並熱烈歡迎您成為我們的正職夥伴，進一步的在未來與我們一起成長並茁壯。"
    }
  }), _vm._v(" "), _c('ContentBlock', {
    attrs: {
      "labelName": "Reason",
      "labelNo": "05",
      "illustration": _vm.images.why05,
      "enTitle": "Build your own record",
      "cnTitle": "累積實戰經驗",
      "contentText": "這裡你將有機會接觸各領域的領導品牌客戶，參與可能超過上萬人使用的產品專案，在短時間內累積豐富的實戰經驗。"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1533d964"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionWhyUs.vue
// module id = 666
// module chunks = 0